import { Language } from '../weborder/Store';
import { Utilities } from '../weborder/Utilities';
import DEFAULT_TRANSLATION from './en.json';
import locales from './locales.json';

export const DEFAULT_LOCALE_CODE = 'en';

declare global {
  export type Translation = typeof DEFAULT_TRANSLATION;
  export type TranslationId = keyof Translation;
}

export const formatLanguageJSON = (translations) => {
  if (translations.length === 1) {
    return {
      ...DEFAULT_TRANSLATION,
      ...translations[0],
    };
  }
  if (translations.length === 2) {
    /**
     * Sequence of array
     * [similar language, language]
     */
    return {
      ...DEFAULT_TRANSLATION,
      ...translations[1],
      ...translations[0],
    };
  }

  return DEFAULT_TRANSLATION;
};

export const availableLanguages = locales.map((l) => l.code);

export const getLocale = (code: string): string => {
  if (availableLanguages.includes(code)) {
    return code;
  }

  if (code.indexOf('-')) {
    const [baseCode] = code.split('-');
    if (availableLanguages.includes(baseCode)) {
      return baseCode;
    }
  }
  return DEFAULT_LOCALE_CODE;
};

function getLanguage(): string {
  if (navigator.languages !== undefined) {
    return navigator.languages[0];
  }
  return navigator.language;
}

export const activeLocaleInRedux = (languages: Language[]): string => {
  const active = (languages || []).find((l) => l?.active);

  return active?.code || DEFAULT_LOCALE_CODE;
};

export const initialLocale = () => {
  const language =
    Utilities.extraOption('data-language') ||
    Utilities.extraOption('data-initial-language') ||
    getLanguage();

  return getLocale(language);
};
